module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('button', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "type": "button",
      "data-toggle": "modal",
      "data-target": _vm.solutionKeyHash
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.getSolution($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.exercise.solvedText')))]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": _vm.solutionKeyId,
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('pages.exercise.solvedText')))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [(_vm.CelotnoVprasanje.solution != null) ? _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.translateVhtml(_vm.CelotnoVprasanje.solution.sl))
    }
  }) : (_vm.fullExercise != undefined && _vm.fullExercise.data.parent == null && _vm.fullExercise.data.questions[_vm.i].solution != undefined) ? _c('div', [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.translateVhtml(_vm.fullExercise.data.questions[_vm.i].solution.sl))
    }
  })]) : (_vm.fullExercise != undefined && _vm.fullExercise.data.parent != null && _vm.fullExercise.data.questions[_vm.i].solution != undefined) ? _c('div', [_c('p', [_vm._v(_vm._s(_vm.$t('pages.exercise.answers.parametricSolution')))]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.translateVhtml(_vm.fullExercise.data.text.sl))
    }
  }), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.translateVhtml(_vm.fullExercise.data.questions[_vm.i].text.sl))
    }
  }), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.translateVhtml(_vm.fullExercise.data.questions[_vm.i].solution.sl))
    }
  })]) : (_vm.fullExercise == undefined || _vm.fullExercise.data.questions[_vm.i].solution == null) ? _c('p', [_vm._v(_vm._s(_vm.$t('pages.exercise.answers.noSolution')))]) : _vm._e()])])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-860b0750", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-860b0750"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/exercises/SolutionModal.vue
// module id = 1422
// module chunks = 1